import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import ProductCard from './ProductCard';
import { productosData } from '../data/productos';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
// Importamos los estilos de la librería por si acaso no estaban cargados globalmente
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import './ProductosDestacados.css'; // Asegurate que el nombre del archivo CSS sea este

// flechas de navegacion
const NextArrow = ({ onClick }) => (
  <div className="custom-arrow next-arrow" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow prev-arrow" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const FeaturedProducts = () => {
  // 1. Creamos una función que calcula cuántos quesos mostrar según el ancho real de la pantalla
  const calcularSlides = () => {
    if (window.innerWidth <= 768) return 1; // Celulares
    if (window.innerWidth <= 1024) return 2; // Tablets
    return 3; // PC
  };

  // 2. Guardamos ese número en el estado de React
  const [slides, setSlides] = useState(calcularSlides());

  // 3. Si el usuario gira el celular o achica la ventana, actualizamos el número en tiempo real
  useEffect(() => {
    const manejarResize = () => {
      setSlides(calcularSlides());
    };

    window.addEventListener('resize', manejarResize);
    return () => window.removeEventListener('resize', manejarResize);
  }, []);

  // 4. Configuración limpia. ¡Chau al bloque 'responsive' problemático!
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: slides, // Le pasamos nuestro propio cálculo infalible
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: slides > 1, // Ocultamos las flechas solo si es celular (slides === 1)
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div style={{ padding: '4rem 1rem', backgroundColor: '#fdfbf7' }}>
      <h2 style={{ 
        textAlign: 'center', 
        fontFamily: 'Playfair Display', 
        color: '#2d5a27',
        fontSize: '2.5rem',
        marginBottom: '2rem'
      }}>
        Nuestros Quesos Destacados
      </h2>
      
      <div className="featured-carousel-wrapper">
        {/* React obliga a slick a renderizar con nuestro número exacto desde el milisegundo cero */}
        <Slider {...settings}>
          {productosData.map(producto => (
            <ProductCard key={producto.id} producto={producto} />
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default FeaturedProducts;